export const Applications = {
  tools: "Tools",
  adminTools: "Administrator tools",
  deleteSelectedTools: "Delete selected tools?",
  deleteToolsDescription:
    "The tools will be unlinked from the toolbox. To link them again, they must be added manually.",
  addTools: "Add tools",
  addSelection: "Add selection",
  deleteSelection: "Delete selection",
  assetTypes: "Asset Types",
  myToolkits: "My toolkits",
  keywords: "Keywords",
  selectOrAddAKeyword: "Add or select a keyword",
  pleaseSelectAToolkit: "Please, select a toolkit.",
  setAsDefault: "Set as default",
  removeDefault: "Remove default",
};
